<template>
  <!-- 購入内容(払い戻し画面) -->
  <div v-if="isReadyToDraw">
    <!-- 有効期限 -->
    <BAvailablePeriod
      v-if="book.user_started_at"
      :period="masterBook.valid_period"
      :start="book.user_started_at"
      :limit="limitedAtMinusStartHour"
    />
    <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
    <!-- availableを使う場合は、valid_period:1daysでも終了日時を表示するので、isBeforeValid=trueで制御　-->
    <BAvailablePeriod
      v-else
      :period="masterBook.valid_period"
      :start="book.available_started_at"
      :limit="limitedAtMinusStartHour"
      :is-before-valid="true"
    />
    <!-- 有効期限 -->

    <!-- 発駅 -->
    <BFromStationSelect
      v-if="book.price && book.price.from_station"
      :name="book.price.from_station.name"
    />
    <!-- 発駅 -->

    <!-- 購入枚数 -->
    <BgDivisionCount :label="bookGroup.divisions_label" />
    <!-- 購入枚数 -->

    <!-- 料金 -->
    <BgMyTicketPaymentAmount
      :total-price="divisionCalTotalPrice"
      :is-visible-price="
        bookGroup.master_book_sales_corporation == null
          ? true
          : bookGroup.master_book_sales_corporation.visible_price
      "
    />
    <!-- 料金 -->

    <hr />

    <!-- 手数料 -->
    <BgRefundServiceCharge :charge="divisionCalTotalPrice - refundTotal" />
    <!-- 手数料 -->

    <!-- 返金額 - 手数料 -->
    <BgRefundAmount
      :amount="refundTotal"
      :is-visible-price="
        bookGroup.master_book_sales_corporation == null
          ? true
          : bookGroup.master_book_sales_corporation.visible_price
      "
    />
    <!-- 返金額 - 手数料 -->

    <hr />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";

import bookGroupService from "@/services/bookGroup";
import myTicketsCommonService from "@/services/common/myTickets";

export default {
  name: "TheTicketPurchaseDetailsOfRefund",
  components: {},
  setup() {
    const store = useStore();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);

    const isReadyToDraw = ref(false);
    const divisionCalTotalPrice = computed(() =>
      bookGroupService.calTotal(bookGroup.value)
    );
    const limitedAtMinusStartHour = computed(() => {
      // book.user_XXX_atがある場合
      if (book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // book.user_XXX_atがない場合
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    const refundTotal = computed(() => {
      var refundTotal = 0;
      bookGroup.value.books.forEach(function (book) {
        refundTotal = refundTotal + book.price.refund_price;
      });
      return refundTotal;
    });

    watchEffect(() => {
      if (divisionCalTotalPrice.value > 0) {
        isReadyToDraw.value = true;
      }
    });

    return {
      masterBook,
      book,
      bookGroup,
      divisionCalTotalPrice,
      refundTotal,
      isReadyToDraw,
      limitedAtMinusStartHour,
    };
  },
};
</script>
